function newFormatMoney (t, e = "${{amount_with_period_and_space_separator}}") {
    function n(t, e) {
        return void 0 === t ? e : t
    }

    function o(t, e, o, i) {
        if (e = n(e, 2), o = n(o, ","), i = n(i, "."), isNaN(t) || null == t) return 0;
        var r = (t = (t / 100).toFixed(e)).split(".");
        return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (r[1] ? i + r[1] : "")
    }

    "string" == typeof t && (t = t.replace(".", ""));
    var i = "",
        r = /\{\{\s*(\w+)\s*\}\}/,
        a = e || window.tlFreeGiftBlock.money_format;
    switch (a.match(r)[1]) {
        case "amount":
            i = o(t, 2);
            break;
        case "amount_no_decimals":
            i = o(t, 0);
            break;
        case "amount_with_comma_separator":
            i = o(t, 2, ".", ",");
            break;
        case "amount_with_space_separator":
            i = o(t, 2, " ", ",");
            break;
        case "amount_with_period_and_space_separator":
            i = o(t, 2, " ", ".");
            break;
        case "amount_no_decimals_with_comma_separator":
            i = o(t, 0, ".", ",");
            break;
        case "amount_no_decimals_with_space_separator":
            i = o(t, 0, " ");
            break;
        case "amount_with_apostrophe_separator":
            i = o(t, 2, "'", ".")
    }
  return a.replace(r, i)
};

function salepifyRenderGiftBox() {
    // Hide arrows when number of gifts < 3
    if (window.tlFreeGiftBlock.displayRule.list_childs.length < 3) {
        window.tlFreeGiftBlock.freeGiftBlock.querySelector('.salepify-embed-widget-main-offer').style.display = "none";
    }

    if (window.tlFreeGiftBlock.displayRule.show_free_gift_widget) {
        // Hide claim button
        window.tlFreeGiftBlock.claimButton.style.display = "none";
        window.tlFreeGiftBlock.claimButton.querySelector(".salepify-embed-widget-claim-button__text").innerHTML = window.tlFreeGiftBlock.replaceVariables(window.tlFreeGiftBlock.translation.main_offer.claim_btn, ["{{name}}", "{{remain}}", "{{gift_number}}"])
        
        window.tlFreeGiftBlock.blockTitle.innerHTML = window.tlFreeGiftBlock.replaceVariables(window.tlFreeGiftBlock.translation.header.title, ["{{name}}", "{{remain}}", "{{gift_number}}"])

        window.tlFreeGiftBlock.renderNumberGiftSelected();
        window.tlFreeGiftBlock.headerBlock.innerHTML = `
          <div>FREE ITEM WITH PURCHASE</div> <div style="
              color: #000000;
              font-weight: 500;
              font-size: 14px;
          ">Promo item will add to cart automatically</div>`;
        if (window.tlFreeGiftBlock.remain <= 0) {
            if (window.tlFreeGiftBlock.isClaimed) {

               
            } else {

                window.tlFreeGiftBlock.claimButton.style.display = window.tlFreeGiftBlock.displayRule.auto_add_gift ? "none" : "block"
                window.tlFreeGiftBlock.showConfetti();
            }

        } else {
            window.tlFreeGiftBlock.isShowedFirework = false;
        }

        window.tlFreeGiftBlock.setGiftActionStatus(true);
        
        // Show free gift block when show_free_gift_widget == true
        window.tlFreeGiftBlock.freeGiftBlock.style = "display: flex";
    }else {
        // Hide free gift block when show_free_gift_widget == false
        window.tlFreeGiftBlock.freeGiftBlock.style = "display: none";
    }
}
  
      
const overwriteRenderAdvancedFreeGift = () => {
  if (window.tlFreeGiftBlock) {
    clearInterval(intervalId);
    window.tlFreeGiftBlock.renderGiftBox = salepifyRenderGiftBox;
    console.log("overwrite")
    window.tlFreeGiftBlock.formatMoney= newFormatMoney;
  }
}

const intervalId = setInterval(overwriteRenderAdvancedFreeGift, 50);
setTimeout(() => {
  clearInterval(intervalId);
}, 3000);